import { ClubTierTypes, ClubMemberRoles } from './clubs';

/**
 * Get default custom fields for Statsig user
 * @param {Object} user - The user object from Redux state
 * @returns {Object} Default custom fields object for Statsig
 */
export const getDefaultCustomFields = (user) => {
    if (!user) {
        return {};
    }

    return {
        isClubOrganizer: user.isClubOrganizer,
        isEnterpriseClubOrganizer: user.isEnterpriseClubOrganizer,
        isSpecialClubOrganizer: isUserClubOrganizer(user, ClubTierTypes.SPECIAL),
        isPremiumLiteClubOrganizer: isUserClubOrganizer(user, ClubTierTypes.PREMIUM_LITE),
        isPremiumZeroTenClubOrganizer: isUserClubOrganizer(user, ClubTierTypes.PREMIUM_ZERO_TEN),
        isFlexLeagueEventOrganizer: isUserClubOrganizer(user, ClubTierTypes.FLEX_LEAGUE),
        isHighSchoolOrganizer: isUserClubOrganizer(user, ClubTierTypes.HIGH_SCHOOL) || isUserClubOrganizer(user, ClubTierTypes.PERFORMANCE_HIGH_SCHOOL),
        isCollegeOrganizer: isUserClubOrganizer(user, ClubTierTypes.FREE_COLLEGE) || isUserClubOrganizer(user, ClubTierTypes.PRO_COLLEGE),
        isPremiumTenClubOrganizer: isUserClubOrganizer(user, ClubTierTypes.PREMIUM_TEN),
        isPremiumClubOrganizer: isUserClubOrganizer(user, ClubTierTypes.PREMIUM),
        isPowerUser: user.isPowered,
    };
};

const isUserClubOrganizer = (user, tierTypeId) => {
    return user.clubMemberships?.some(clubMembership => (clubMembership.roleId === ClubMemberRoles.Owner || clubMembership.roleId === ClubMemberRoles.Admin) && clubMembership.tierTypeId === tierTypeId);
};
